export default __webpack_public_path__ + "static/management-portfolio-e5426bc37e7b464125a4b5e7fa012c29.svg";